import React, {useMemo} from 'react';
import {Editor} from "@tinymce/tinymce-react";
import type {Editor as TinyMCEEditor} from 'tinymce';
import {Box, Skeleton} from "@mui/material";

interface OwnProps {
  content: string;
  setContent: (s: string) => void;
  showMenus?: boolean;
  "data-cy"?: string;
  height?: number;
  disabled?: boolean;
}

const TinyMCEditor: React.FC<OwnProps> = (props) => {
  const {content, setContent, showMenus=true, height=400, disabled=false} = props;
  const [loaded, setLoaded] = React.useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialContent = useMemo(() => content, []);
  return (
    <>
      {!loaded && showMenus && <Skeleton variant="rectangular" height={40} sx={{marginBottom: '5px'}} />}
      {!loaded && <Skeleton variant="rectangular" height={400} />}
      <Box data-cy={loaded && props['data-cy']}>
        <Editor
          apiKey={'j9g10jh399s2koxj1yskca984rscc0ib3miq9wdw2u65nwxa'}
          initialValue={initialContent}
          onEditorChange={(newText: string) => setContent(newText)}
          disabled={disabled}
          init={{
            height: height,
            menubar: false,
            toolbar: showMenus ? 'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | link image' : false,
            setup: function (ed: TinyMCEEditor) {
              ed.on('init', function() {
                setLoaded(true)
              });
            }
          }}
        />
      </Box>
    </>
  );
}

export default TinyMCEditor;
